import React from "react";
import { useSelector } from "react-redux";
import Loading from "../Loading/Loading";
import { Navigate } from "react-router-dom";

const UserRoute = ({ children }) => {
  const user = useSelector((state) => state.user.user);
  const isAuthanticated = useSelector((state) => state.user.isAuthantication);
  const token = localStorage.getItem("instapass_user_token");

  if (token) {
    if (user && Object.keys(user).length > 0) {
      if (user?.firstName && isAuthanticated === true) {
        return <>{children}</>;
      }
      return <Navigate replace to="/login" />;
    }
    return (
      <div className="w-full flex justify-center place-items-center">
        <Loading />
      </div>
    );
  }
  return <Navigate replace to="/login" />;
};

export default UserRoute;
